import { render } from "./AboutSectionPC.vue?vue&type=template&id=f3d0aee2&scoped=true"
import script from "./AboutSectionPC.vue?vue&type=script&lang=js"
export * from "./AboutSectionPC.vue?vue&type=script&lang=js"

import "./AboutSectionPC.vue?vue&type=style&index=0&id=f3d0aee2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3d0aee2"]])

export default __exports__